var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.361,
    height: 19.361,
    viewBox: "0 0 19.361 19.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6620",
    "data-name": "Path 6620",
    d: "M22.978,16.064H16.064v6.915a1.383,1.383,0,1,1-2.766,0V16.064H6.383a1.383,1.383,0,1,1,0-2.766H13.3V6.383a1.383,1.383,0,1,1,2.766,0V13.3h6.915a1.383,1.383,0,1,1,0,2.766Z",
    transform: "translate(-5 -5)",
    fill: "#f7f8fa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/NewIcon.da9a5e78b58bca7a58e92e14fe08e1b3.svg";
export { ForwardRef as ReactComponent };